// Copyright (c) 2022 by Move Closer

import { RawLocation } from 'vue-router'
import { AnyObject } from '@movecloser/front-core'

import { ImageProps } from '../../../../dsl/atoms/Image'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface ArticleCardProps {
  /**
   * Category of the article.
   */
  categories?: AnyObject[]

  /**
   * Content (Body text) of the article.
   */
  content: string

  /**
   * Article image.
   */
  cover?: ImageProps

  /**
   * Heading (title) of the article.
   */
  heading: string

  /**
   * Layout - vertical (default) or horizontal
   */
  layout?: ArticleCardLayout

  /**
   * Determines link for the article.
   */
  link?: RawLocation

  /**
   * Date of publication of article.
   */
  publicationDate: string
}

export enum ArticleCardLayout {
  Horizontal = 'horizontal',
  Vertical = 'vertical'
}
